import React, { PropTypes } from "react";
import styled from "styled-components";
import colors from "../../styles/colors";
import fonts from "../../styles/fonts";

const OuterWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
`;

const Wrapper = styled.div`
  background-color: ${colors.background};
  border: 1px solid ${colors.border};
  display: block;
  font-family: ${fonts.main};
  font-weight: 400;
  height: 240px;
  margin: 0 auto;
  top: 50%;
  transform: translateY(-50%);
  width: 348px;

  > form {
    padding: 25px 30px;

    > h2 {
      color: ${colors.accent};
      font-family: ${fonts.header};
      font-size: 1.1rem;
      font-weight: 900;
      letter-spacing: 0.05rem;
      margin-bottom: 20px;
      margin-top: 0px;
      text-align: center;
      text-transform: uppercase;
    }

    > p {
      font-size: 13px;
      line-height: 1.7;
      position: relative;
      margin-top: 15px;
      margin-bottom: 0px;
      text-align: left;

      > .input {
        border: 1px solid ${colors.border};
        font-family: ${fonts.main};
        font-size: 16px;
        margin-bottom: 5px;
        margin-top: 5px;
        padding: 4px 7px;
        max-width: 100%;
        width: 100%;
      }
    }

    > .submit {
      background-color: white;
      border: 1px solid #8cd0c5;
      border-radius: 3px;
      color: #8cd0c5;
      cursor: pointer;
      display: inline-block;
      font-family: ${fonts.header};
      font-size: 12px;
      font-weight: 500;
      letter-spacing: 1px;
      margin-left: 50%;
      margin-top: 20px;
      padding: 5px 8px;
      position: relative;
      text-transform: uppercase;
      transform: translateX(-50%);
      transition: all 0.4s ease;

      &:hover {
        background-color: rgba(140, 208, 197, 0.2);
      }
    }
  }
`;

export default class Authorization extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      password: "",
      denied: false,
    };
  }

  setCookie = (cname, cvalue, exdays) => {
    var d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  };

  handleSubmit = (e) => {
    const { password } = this.state;
    if (password == "Latijnisstampen") {
      this.setCookie("cerberus", true, 2);
      location.reload();
    } else {
      this.setState({ denied: true });
    }

    e.preventDefault();
  };

  handleChange = (e) => this.setState({ [e.target.name]: e.target.value });

  render() {
    const { denied, password } = this.state;
    return (
      <OuterWrapper>
        <Wrapper>
          <form name="authorization" onSubmit={this.handleSubmit}>
            <h2>Wachtwoord</h2>
            {denied ? (
              <p>Dat was niet het juiste wachtwoord. Probeer het nog eens.</p>
            ) : (
              <p>Vul het wachtwoord in om toegang te krijgen tot deze site.</p>
            )}

            <p>
              <input
                className="input"
                name="password"
                type="password"
                autoFocus
                autoComplete="current-password"
                value={password}
                onChange={this.handleChange}
              />
            </p>

            <button type="submit" className="submit">
              Verzenden
            </button>
          </form>
        </Wrapper>
      </OuterWrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/layout/Authorization.js